import { render, staticRenderFns } from "./CustomPayment.vue?vue&type=template&id=3d8cd504&scoped=true"
import script from "./CustomPayment.vue?vue&type=script&lang=ts"
export * from "./CustomPayment.vue?vue&type=script&lang=ts"
import style0 from "./CustomPayment.vue?vue&type=style&index=0&id=3d8cd504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8cd504",
  null
  
)

export default component.exports